import { DatePipe } from '@angular/common';
import { Component, inject, input, LOCALE_ID } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { IInverterList } from '../../../../models/inverter';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-inverter-table',
  imports: [PanelModule, TableModule, DatePipe],
  templateUrl: './inverter-table.html',
  styleUrl: './inverter-table.css',
})
export class InverterTable {
  inverterList = input.required<IInverterList[]>();
  isLoading = input.required<boolean>();
  readonly locale = inject(LOCALE_ID);
  readonly iconsStyles = inject(IconsStyles);
  readonly customFunctions = inject(Functions);
  readonly shouldBeCollapsed = this.customFunctions.shouldBeCollapsed();
}
